import { cle, litteral, type Mot } from '@/lib/mots';
/**
 * frontend/src/modules/search/types.ts
 * PHASE 3.2 F2 — Types recherche globale.
 */

export type SearchResultType = 'pdv' | 'brand' | 'market_cluster' | 'module' | 'sku'

export interface SearchResultItem {
  id:    string
  type:  SearchResultType
  code:  string
  name:  string
  meta?: string
  rank:  number
}

export interface SearchResponse {
  q:       string
  total:   number
  results: SearchResultItem[]
}

/** Icon type per result category */
/**
 * ⚠ `#810` — la table porte des **mots**, résolus au rendu. `Cluster` et
 *   `Module` sont des **invariants `#800`** (FR == EN) : ils restent littéraux.
 */
export const RESULT_TYPE_MOTS: Record<SearchResultType, Mot> = {
  pdv:            cle('commun.pdv'),
  brand:          cle('marche.filtre.marque'),
  market_cluster: litteral('Cluster'),
  module:         litteral('Module'),
  sku:            cle('commun.modele'),
}
